import { faEdit, faEye, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import Table from '../../Common/table';
import swal from 'sweetalert';
import axios from 'axios';
import dateTime from '../../utill/dateTime';
import api from '../../config.json'
import Excelimport from '../../utill/Excelimport';
import Loading from '../../utill/LoadingComponent';

const ListTable = ({ history, location, RightName, getRightsForAccess ,Heading}) => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'ListName', order: 'asc' })

    useEffect(() => {
        Heading('List Master')
        handleGetData()
    }, [])

    const handleGetData = () => {
        axios.get(api.api + 'ListMaster')
            .then((result) => {
                // consol(result.data)
                setLoader(false)
                setList(result.data);
            })
            .catch((err) => {
                swal(`${err}`)
                setLoader(false)
            })
    }

    const onDelete = (data) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this",
            icon: "warning",
            buttons: true,
            dangerMode: true
        }).then(willDelete => {
            if (willDelete) {
                setLoader(true)
                axios
                    .delete(api.api + "ListMaster/" + data._id, { data: data })
                    .then(result => {
                        // consol(result.data)
                        if (result.data.ok === 1 && result.data.deletedCount === 1) {
                            handleGetData();
                            setLoader(false)
                        }
                    })
                    .catch(err => {
                        setLoader(false)
                        if (err.response && err.response.data) {
                            swal(`${err.response.data.message}`);
                        } else {
                            swal(`${err}`);
                        }

                    });
            } else {
                setLoader(false)
            }
        });
    }


    const columns = [
        { path: 'ListName', label: 'List Name' },
        { key: 'Contents', label: 'No Of Contents', content: (obj) => <React.Fragment>{obj.contents.length}</React.Fragment> },
        { key: 'createdAt', label: 'Created Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.createdAt)}</label><br /></React.Fragment> },
        { key: 'updatedAt', label: 'Last Updated Date', content: (obj) => <React.Fragment><label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label><br /></React.Fragment> },
        { key: 'view', content: user => <button onClick={() => history.push("/setting/list/form", { action: "view", data: user })} className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faEye} /></button> },
        { key: 'update', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => history.push("/setting/list/form", { action: "update", data: user })} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEdit} /></button> },
        { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }

    ]

    return (<>
        {loader ? <Loading /> : <></>}
        {/* <div className='text-center'>
            <p>List Master</p>
        </div> */}
        {getRightsForAccess('StaticDataRights', RightName, "write") && <a onClick={() => history.push('/setting/list/form', { action: "add", data: {} })} style={{ cursor: 'pointer' }} className='float-right common-anchor'

        >
            <FontAwesomeIcon size='1x' icon={faPlus} /> Add </a>}
        {/* <a
          style={{ cursor: "pointer", color: 'white' }}
          className="float-left btn btn-sm btn-primary "
          //onClick={this.handleUploadGuagesDoc}
        >
          {" "}

          <FontAwesomeIcon size="1x" icon={faFileImport} /> Import Excel
        </a> */}
        {getRightsForAccess('StaticDataRights', RightName, "write") && <Excelimport />}
        {list.length < 0 ? "Data Not Available" : <Table sortColumn={sortColumn} columns={columns} data={list} />}

    </>);
}

export default ListTable;